import * as Yup from "yup";

export const measureMethods = [
    {
        id: "weight",
        name: "Weight"
    },
    {
        id: "cbm",
        name: "CBM"
    },
    {
        id: "unit",
        name: "Unit"
    }
]

export const validationSchema = Yup.object({
    rateName: Yup
        .string()
        .required("Required"),
    description: Yup
        .string()
        .required("Required"),
    locationId: Yup
        .string()
        .min(1, "Min 1 selection")
        .required('Required'),
})

export const initialValues = {
    rateName: "",
    locationId: "",
    description: "",
    status: true,
}